<script>
import { _ } from './services/i18n';
</script>

<section class="contacts-section" id="contacts">
  <div class="heading-module">
    <h2>{$_('contacts.title')}</h2>
  </div>
  <div class="contacts">
    <form action="https://formsubmit.co/marta@printingagent.eu" method="POST" class="form">
      <h3>{$_('contacts.writeus')}</h3>
      <div class="input-box">
        <input type="text" class="inputField" name="name" id="name" required />
        <label for="name" class="label"
          >{$_('contacts.name')} <span class="asterix">*</span></label
        >
      </div>
      <!-- <input type="hidden" name="_next" value="https://https://courageous-heliotrope-dec646.netlify.app/#thanks"> -->
      <div class="input-box">
        <input type="text" class="inputField" id="email" name="email" required />
        <label for="email" name="email" class="label"
          >{$_('contacts.email')} <span class="asterix">*</span></label
        >
      </div>
      <div class="input-box">
        <textarea class="inputField" name="message" id="message" required />
        <label for="message" class="label"
          >{$_('contacts.msg')} <span class="asterix">*</span></label
        >
      </div>
      <button type="submit" class="btn">{$_('contacts.send')}</button>
    </form>
    <div class="contact-info">
      <img src="/assets/undraw.svg" alt="undraw" />
      <div class="contact-info-box">
        <p>
          <a href="tel:+371 20000000"
            ><i class="fa-solid fa-square-phone" />+371 26 320 424</a
          >
        </p>
        <p>
          <a href="mailto:marta@printingagent.eu"
            ><i class="fa-solid fa-envelope" />marta@printingagent.eu</a
          >
        </p>
        <p><i class="fa-solid fa-location-dot" />{$_('contacts.riga')}</p>
      </div>
    </div>
  </div>
</section>

<style>
  h2,
  h3,
  p,
  a,
  i,
  input,
  label,
  textarea {
    color: var(--mainWhite);
  }
  h2 {
    font-size: 2rem;
  }
  p {
    padding-bottom: 0.5rem;
    font-size: 1.1rem;
  }
  i {
    padding-right: 10px;
    transition: all 300ms ease-in-out;
  }
  .contacts-section {
    padding-bottom: 3rem;
    position: relative;
    background-color: var(--textColor);
  }
  .heading-module {
    width: 400px;
    max-width: 100%;
    height: 130px;
    display: flex;
    align-items: center;
    padding-left: 1rem;
    background-color: var(--primaryColor);
    position: absolute;
    top: -5%;
  }
  .contacts {
    display: flex;
    flex-direction: column-reverse;
    gap: 4rem;
    width: 100%;
    padding-top: 6rem;
    padding: 6rem 1rem;
  }
  .contact-info {
    margin-top: 1rem;
    position: relative;
  }
  .contact-info img {
    width: 100%;
  }
  .contact-info-box {
    position: absolute;
    top: 55%;
    left: 40%;
  }
  .contact-info a {
    transition: all 300ms ease-in-out;
  }
  .contact-info p {
    transition: all 300ms ease-in-out;
    cursor: pointer;
  }
  .contact-info p:hover {
    color: var(--primaryColor);
  }
  .contact-info p:hover i {
    color: var(--primaryColor);
  }
  .contact-info a:hover {
    color: var(--primaryColor);
  }
  .contact-info a:hover i {
    color: var(--primaryColor);
  }
  .form {
    display: flex;
    flex-direction: column;
    width: 600px;
    margin: 0 auto;
  }
  h3 {
    font-size: 1.5rem;
  }
  .input-box {
    width: 100%;
    position: relative;
  }
  input {
    height: 50px;
  }
  textarea {
    height: 100px;
  }
  .inputField {
    width: 100%;
    padding: 1rem;
    font-size: 1rem;
    border: 1px solid var(--primaryColor);
    margin: 1rem 0;
    background-color: transparent;
  }
  .inputField:focus,
  .inputField:valid {
    outline-color: var(--mainWhite);
  }
  .inputField:focus + label,
  .inputField:valid + label {
    top: 10px;
    left: 10px;
    padding: 0 5px;
    font-size: 13px;
    background-color: var(--textColor);
  }
  .label {
    position: absolute;
    top: 25px;
    left: 5px;
    padding: 0 5px;
    font-weight: 500;
  }
  .asterix {
    color: var(--primaryColor);
  }
  .btn {
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--primaryColor);

    background-color: var(--primaryColor);
    color: #141824;
    font-size: 1.5rem;
    font-weight: 500;
    letter-spacing: 2px;
    border: none;
    position: relative;
    z-index: 0;
    overflow: hidden;
    transition: all 400ms ease-in-out;
    cursor: pointer;
  }
  .btn:hover {
    outline: 1px solid var(--primaryColor);
    color: var(--primaryColor);
  }
  .btn::before {
    content: '';
    background-color: #141824;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    -webkit-transform: translate(-100%) rotate(10deg);
    transform: translate(-100%) rotate(10deg);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    width: 100%;
    will-change: transform;
    z-index: -1;
    transition: all 400ms ease-in;
  }
  .btn:hover::before {
    transform: translate(0);
  }

  @media (max-width: 850px) {
    .contacts-section {
      gap: 1rem;
    }
    .contacts-section {
      flex-direction: column;
    }
  }

  @media (max-width: 768px) {
    .form {
      width: 100%;
    }
    .contact-info-box {
      top: 50%;
      left: 35%;
    }
    p {
      font-size: 1rem;
    }
  }
  @media (max-width: 430px) {
    .contact-info {
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      justify-content: center;
      gap: 2rem;
    }
    .contact-info-box {
      position: static;
    }
  }
</style>
